import * as Types from '@wandb/cg';

export const inputType = Types.ALL_DIR_TYPE;
